import { configString } from 'utils/config';

const getSearchIndex = (sort?: string | null | undefined) => {
  if (sort === 'relevance') {
    return configString('algolia', 'siteIndexName');
  }

  return configString('algolia', 'sitePublishedDescIndexName');
};

export default getSearchIndex;
